<template>
    <div class="float-left">
        <i
            class="fa fa-search-plus fa-lg icon-button"
            title="Documentos da Despesa"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">Documentos da Despesa</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasMensal"
                                >Prestação Mensal</label
                            >
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="
                                        prestacaoContasFinal.idPrestacaoContasMensal
                                    "
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasFinal">Despesa</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasFinal"
                                    type="text"
                                    v-model="
                                        prestacaoContasFinal.idPrestacaoContasFinal
                                    "
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtEmissao">Data Emissão</label>
                            <b-input-group>
                                <b-form-input
                                    id="dtEmissao"
                                    type="text"
                                    v-model="prestacaoContasFinal.dtEmissao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalGasto">Valor</label>
                            <b-input-group>
                                <money
                                    id="nuTotalGasto"
                                    v-model="prestacaoContasFinal.nuValor"
                                    v-bind="money"
                                    class="form-control text-right"
                                    @input.native="$v.valor.$touch()"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback
                                    >Total Despesas é
                                    obrigatória</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Documentos </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="DocumentoConvenio"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false"
                                >
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <btn-prestacao-contas-final-documentos
                                                class="mr-2"
                                                v-if="
                                                    $temAcessoView(
                                                        'CONV-MEN-DES-DOC-01'
                                                    )
                                                "
                                                :parentData="
                                                    prestacaoContasFinal
                                                "
                                                :idConvenio="0"
                                                @atualizarLista="
                                                    obterDocumentosPrestacaoFinal()
                                                "
                                            >
                                            </btn-prestacao-contas-final-documentos>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span
                                            class="text-danger float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-DOC-02'
                                                )
                                            "
                                        >
                                            <i
                                                class="
                                                    fa fa-trash fa-lg
                                                    icon-button
                                                "
                                                title="Excluir Documento"
                                                @click.stop="
                                                    confirmarExcluirDocumento(
                                                        data.id_Documento
                                                    )
                                                "
                                            ></i>
                                        </span>
                                        <span
                                            class="text-success float-left mr-1"
                                        >
                                            <i
                                                class="
                                                    fa fa-download fa-lg
                                                    icon-button
                                                "
                                                title="Download"
                                                @click.stop="
                                                    confirmarDownload(data)
                                                "
                                            ></i>
                                        </span>

                                        <span
                                            class="text-primary float-left mr-1"
                                        >
                                            <VisualizarDocumento
                                                :parentData="data"
                                            >
                                            </VisualizarDocumento>
                                        </span>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template
                                        slot="dtEmissao"
                                        slot-scope="data"
                                    >
                                        <p class="text-left m-0">
                                            {{
                                                data.dtEmissao
                                                    ? $moment(
                                                          data.dtEmissao
                                                      ).format('DD/MM/YYYY')
                                                    : ''
                                            }}
                                        </p>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ConveniosServicos from '../ConveniosServicos'
import BtnPrestacaoContasFinalDocumentos from './BtnPrestacaoContasFinalDocumentos.vue'
import VisualizarDocumento from './VisualizarDocumentos.vue'

export default {
    props: {
        prestacaoContasFinal: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        BtnPrestacaoContasFinalDocumentos,
        VisualizarDocumento
    },

    validations: {
        valor: {
            required,
            minValue: minValue(0.01)
        }
    },

    data() {
        return {
            habilitaCampos: true,
            tabIndex: 0,
            valor: 0,
            mostrarModal: false,
            //arquivo:{},
            /*imagens: [
                'https://media.gazetadopovo.com.br/2020/01/17155825/lamborghini-huracan-Alexander-Migl-wikimedia-commons.jpg'
            ],*/
            //imagens: [],
            arquivo: [],
            //blob: Blob,
            //url: "",

            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            itensPorPagina: 5,
            DocumentoConvenio: [],
            campos: [
                {
                    key: 'id_Documento',
                    label: 'id',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'tipoDocumento.vcDescricaoTipoDocumento',
                    label: 'Tipo Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcDescricaoDocumento',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcNomeArquivo',
                    label: 'Arquivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        abrirModal() {
            if (!this.desativarBotao) {
                this.mostrarModal = true
                this.obterDocumentosPrestacaoFinal()
            }
        },

        fecharModal() {
            this.mostrarModal = false
        },

        fecharModalImagem() {
            this.arquivo = null
        },

        confirmarExcluirDocumento(id) {
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir o Documento ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ExcluirDocumento(id)
                }
            })
        },

        ExcluirDocumento(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirDocumentosPrestacaoContasFinal(id).then(
                (response) => {
                    if (response) {
                        this.obterDocumentosPrestacaoFinal()
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterDocumentosPrestacaoFinal() {
            if (this.prestacaoContasFinal.idPrestacaoContasFinal > 0) {
                this.prestacaoContasFinal.dtEmissao = this.$moment(
                    this.prestacaoContasFinal.dtEmissao,
                    'YYYY-MM-DD'
                ).format('DD/MM/YYYY')

                this.$store.dispatch('addRequest')
                ConveniosServicos.obterDocumentosPrestacaoContaFinal(
                    this.prestacaoContasFinal.idPrestacaoContasFinal
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.DocumentoConvenio = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        confirmarDownload(doc) {
            this.$swal({
                title: 'Download',
                html: 'Confirma o Download do Documento ?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.download(doc)
                }
            })
        },

        download(doc) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.downloadDocumentoPrestacaoFinal(
                doc.id_Documento
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro no Download!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, doc.vcNomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
